import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { LogoSection } from "../LogoSection";
import { HeaderStyles } from "./Header.styles";
import ProfileSection from "./ProfileSection";
export var Header = function () {
    var sx = HeaderStyles();
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: sx.wrapper, children: _jsx(Box, { component: "span", sx: sx.content.logo, children: _jsx(LogoSection, {}) }) }), _jsx(Box, { sx: sx.content.space }), _jsx(Box, { sx: sx.content.space }), _jsx(ProfileSection, {})] }));
};
